export default {
  noResult: {
    notes: 'Text when the search criteria renders no results',
    message: 'No products found',
  },
  moreMatches: {
    notes: 'Text when more matches than can be displayed',
    message: 'More matches found.',
  },
  action: {
    showAll: {
      notes: 'Button text to show all search results',
      message: 'Show all',
    },
  },
};
